/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DiscordAnalyticsMentorsListDashboard from "../../../../components/DiscordAnalytics/Mentors/Dashboard";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const DiscordAnalyticsMentorsDashboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.discordAnalytics?.hasMentorsListAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscordAnalyticsMentorsListDashboard adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscordAnalyticsMentorsDashboard;
